export default "__VITE_ASSET__aa3b399f__"